import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CalendarDays } from "lucide-react";
import InnerHero from "../components/InnerHero";

const ieiActivities = [
  {
    chapter: "IEI students chapter",
    branch: "E&CE",
    event: "One Day Workshop on Acquaintance with electronic equipment's",
    year: "2024",
  },
  {
    chapter: "IEI students chapter",
    branch: "E&CE",
    event: "Mock Interview preparations for upcoming placement drive",
    year: "2025",
  },
  {
    chapter: "IEI students chapter",
    branch: "CV",
    event: "Industry visit to Connect Industry Pvt Ltd, Dharwad",
    year: "2024",
  },
  {
    chapter: "IEI students chapter",
    branch: "CV",
    event: "Technical Talk on Career Opportunities in Construction Technology and Project Management",
    year: "2024",
  },
  {
    chapter: "IEI students chapter",
    branch: "CSE (AIML)",
    event: "Technical Talk on Cyber security and digital forensics",
    year: "2025",
  },
  {
    chapter: "IEI students chapter",
    branch: "CSE (AIML)",
    event: "Technical Talk on React js and Angular js",
    year: "2025",
  },
  {
    chapter: "IEI students chapter",
    branch: "E&E",
    event: "Alumni Talk on Building the bridge: From undergraduate to MS in engineering",
    year: "2024",
  },
  {
    chapter: "IEI students chapter",
    branch: "E&E",
    event: "Alumni Talk on Employment opportunities in Electrical and Electronics Engineering",
    year: "2024",
  },
  {
    chapter: "IEI students chapter",
    branch: "ME",
    event: "Talk on Entrepreneurial path in material handling technology",
    year: "2025",
  },
  {
    chapter: "IEI students chapter",
    branch: "ME",
    event: "Industrial visit to Deccan Cranes and immortal valve Pvt. Ltd Belur",
    year: "2025",
  },
  {
    chapter: "IEI students chapter",
    branch: "CSE",
    event: "Technical Talk on Importance of AI agents in software Development",
    year: "2025",
  },
  {
    chapter: "IEI students chapter",
    branch: "CSE",
    event: "Technical talk on React js and Angular js",
    year: "2025",
  },
  {
    chapter: "IEI students chapter",
    branch: "E&CE",
    event: "Analog Circuit Design using Cadence",
    year: "2026",
  },
  {
    chapter: "IEI students chapter",
    branch: "ALL Branches",
    event: "Self-Paced FDP on LATEX",
    year: "2026",
  },
  {
    chapter: "IEI students chapter",
    branch: "ALL Branches",
    event: "Nextgen AI user Competition",
    year: "2026",
  },
  {
    chapter: "IEI students chapter",
    branch: "E&CE",
    event: "Technical Talk on FROM RESET TO RUN: MASTERING STM32F407 ARCHITECTURE",
    year: "2026",
  },
  {
    chapter: "IEI students chapter",
    branch: "CSE",
    event: "Technical Talk on HOW AI IS CREATING THE NEXT GENERATION OF ENTREPRENEURS",
    year: "2026",
  },
  {
    chapter: "IEI students chapter",
    branch: "EEE",
    event: "Technical Talk on CAREER OPPORTUNITY FOR ELECTRICAL ENGINEERS IN INDUSTRY SAFETY",
    year: "2026",
  },
  {
    chapter: "IEI students chapter",
    branch: "EEE",
    event: "Technical Talk on FROM CIRCUITS TO AI ELECTRICAL ENGINEERING CAREERS IN 2026 AND BEYOND",
    year: "2026",
  },
  {
    chapter: "IEI students chapter",
    branch: "ME",
    event: "Technical Talk on ENGINEERING INNOVATION THROUGH PRODUCT LIFECYCLE MANAGEMENT",
    year: "2026",
  },
  {
    chapter: "IEI students chapter",
    branch: "CSE",
    event: "Technical Talk on SMART DEVICES AND WEARABLE TECHNOLOGY",
    year: "2026",
  },
];

const IEINav = () => (
  <section className="bg-surface-alt/60 border-b border-brand/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex flex-wrap gap-x-6 gap-y-2 text-xs font-sans-ui font-semibold tracking-wider text-brand">
      <Link to="/associations/iei" className="uppercase hover:underline">
        Overview
      </Link>
      <Link to="/associations/iei#achievements" className="uppercase hover:underline">
        Achievements
      </Link>
      <Link to="/associations/iei/activities" className="uppercase hover:underline">
        Activities
      </Link>
      <Link to="/associations/iei/faculty-members" className="uppercase hover:underline">
        Faculty Members
      </Link>
      <Link to="/associations/iei/student-members" className="uppercase hover:underline">
        Student Members
      </Link>
    </div>
  </section>
);

const IEIActivities = () => {
  return (
    <main>
      <InnerHero
        title="IEI Activities"
        image="https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?w=2400"
        breadcrumbs={[
          { label: "Associations & Innovation Hub", to: "/associations" },
          { label: "IEI", to: "/associations/iei" },
          { label: "Activities" },
        ]}
      />

      <IEINav />

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <Link
          to="/associations/iei"
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:underline mb-8"
        >
          <ArrowLeft size={16} />
          Back to IEI
        </Link>

        <div className="bg-white border border-brand/15">
          <div className="p-6 md:p-8 border-b border-brand/10">
            <p className="text-xs uppercase tracking-[0.28em] text-brand font-semibold mb-3">
              IEI Students Chapter
            </p>
            <h1
              className="text-3xl md:text-5xl text-brand font-semibold leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Activities conducted under IEI Students Chapter
            </h1>
          </div>

          <div className="grid gap-5 p-6 md:p-8 md:grid-cols-2">
            {ieiActivities.map((activity, index) => (
              <article
                key={`${activity.branch}-${activity.year}-${index}`}
                className="min-h-[150px] bg-white border-l-4 border-l-brand border-y border-r border-brand/15 p-5 flex flex-col justify-between"
              >
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-sans-ui font-semibold tracking-wide text-brand">
                  <span className="inline-flex items-center gap-1.5">
                    <CalendarDays size={13} />
                    {activity.year}
                  </span>
                  <span>{activity.branch}</span>
                </div>

                <h2
                  className="mt-4 text-xl text-[#2a2a2a] font-semibold leading-snug"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {activity.event}
                </h2>

                <p className="mt-4 text-xs uppercase tracking-[0.18em] text-[#2a2a2a]/60 font-semibold">
                  {activity.chapter}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default IEIActivities;